export enum TripTypeOptions {
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP',
  MULTI_CITY = 'MULTICITY'
}

export enum BookWidgetFieldInfoTypes {
  REFUNDABLE_FARE_ONLY = 'refundableFareField',
  CONNECTION_AIRPORT = 'airportsField'
}

export enum BookWidgetFieldUpdateTypes {
  originAirport = 'originAirport',
  destinationAirport = 'destinationAirport',
  connectionAirport = 'connectionAirport',
  tripType = 'tripType',
  datesChange = 'datesChange',
  passenger = 'passenger',
  shopMiles = 'shopMiles',
  refundableFare = 'refundableFare',
  basicFares = 'basicFares',
  flexDates = 'flexDates',
  flexAirport = 'flexAirport',
  bestFareOptions = 'bestFareOptions',
  meetingEventCode = 'meetingEventCode'
}

export enum BookWidgetCheckboxIds {
  SHOP_WITH_MILES = 'shopWithMiles',
  FLEXIBLE_DATE = 'flexibleDate',
  BASIC_FARES = 'basicFaresField',
  REFUNDABLE_FARES = 'showExtraFareOnly',
  NEARBY_AIRPORTS = 'includeNearByAirport'
}

export enum BookWidgetAnalyticsCategories {
  BEST_FARES_FOR = 'best fares for',
  MEETING_CODE = 'meeting code'
}
